export default __webpack_public_path__ + "static/media/empty_presenter_icon.dd4d6452.svg";